export const OFFERINGS = [
  {
    icon: "/images/offerings/beds",
    title: "King-Sized Comfort in Spacious Rooms",
    desc: "Enjoy a restful stay in our deluxe rooms, featuring plush king-sized beds for ultimate relaxation.",
    img: "/images/offerings/01",
  },
  {
    icon: "/images/offerings/pool",
    title: "Expansive Pools for Relaxation",
    desc: "Dive in and relax! The perfect spot for a refreshing dip and ultimate unwinding.",
    img: "/images/offerings/02",
  },
  {
    icon: "/images/offerings/location",
    title: "Lots happening around you",
    desc: "Surrounded by cafés, restaurants, nightclubs, beaches, and attractions like night markets, water sports, sunset yacht cruises, casinos, and hidden speakeasy bars",
    img: "/images/offerings/03",
  },
  {
    icon: "/images/offerings/verified",
    title: "Owner Managed Villas in North Goa",
    desc: "Stay in a spacious, well-maintained villa with a personal touch, ensuring a comfortable and homely experience.",
    img: "/images/offerings/04",
  },
];
